import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPrivate from "../../api/axiosPrivate";
import axiosPublic from "../../api/axiosPublic";

export const verifyNin = createAsyncThunk(
  "verify/nin",
  async (nin, { rejectWithValue }) => {
    try {
      const { data } = await axiosPublic.get(`verify/nin/${nin}`);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
